<script lang="ts">export let size = "20";
const height = size;
</script>

<svg {height} style="fill: currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
	<path
		d="M17.316 12.696c-.75 2.507-3.258 3.432-5.363 1.97-.288-.21-.547-.448-.836-.627-.115.06-.23.06-.317.12.202 1.103.433 2.177.634 3.341H8.58c.202-1.104.432-2.208.692-3.61-.519.298-.72.418-.923.537-1.412 1.044-2.854 1.104-4.152.179-1.326-.925-2.047-2.685-1.528-4.267.289-.925.779-1.85 1.355-2.655 1.442-2.118 3.345-3.73 5.479-5.072.23-.15.75-.15 1.009 0 2.624 1.73 4.872 3.819 6.4 6.653.549 1.104.78 2.238.404 3.431"
	/>
</svg>
